import * as Yup from 'yup';

const GroupNetworkSchema = Yup.object().shape({
  associatedWithGroupOrNetwork: Yup.string().required('Please select yes or no.'),

});
export default GroupNetworkSchema;
